import React, { useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function ChartHistory_Environment({ irr1, irr2, temp_ambient, humidity, temp_pv, temp_raceway, wind_speed, wind_direct, water_level, xlabel }) {
    const [visible, setVisible] = useState([true, true, true, true, true, true, true, true, true]);

    function toggleDataSeries(e) {
        if (typeof (e.dataSeries.visible) === "undefined" || (e.dataSeries.visible) === undefined || e.dataSeries.visible) {
            const index = e.dataSeriesIndex
            toggleVisibility(index, false)
        } else {
            const index = e.dataSeriesIndex
            toggleVisibility(index, true)
        }
    }

    const toggleVisibility = (indexToChange, new_val) => {
        setVisible(prevVisible =>
            prevVisible.map((val, index) =>
                index === indexToChange ? new_val : val
            )
        );
    };

    let index_windspeed = 0
    let index_winddirect = 0
    let index_waterlevel = 0

    const plot = [
        { color: "#9AE630", unit: 'W/m2', name: 'Irradiation #1', dp: 2 },
        { color: "#FF8904", unit: 'W/m2', name: 'Irradiation #2', dp: 2 },
        { color: "#FB2C36", unit: '°C', name: 'Ambient Temperature', dp: 2 },
        { color: "#E12AFB", unit: '%RH', name: 'Relative Humidity', dp: 2 },
        { color: "#155DFC", unit: '°C', name: 'Panel Temperature', dp: 2 },
        { color: "#31C950", unit: '°C', name: 'Tray Temperature', dp: 2 },
        { color: "#3BB8DB", unit: 'm/sec.', name: 'Wind Speed', dp: 2 },
        { color: "#F6339A", unit: 'Deg.', name: 'Wind Direction', dp: 2 },
        { color: "#314158", unit: 'm.', name: 'Water Level', dp: 2 },
    ]

    let axisy = [{
        title: 'Irradiation (W/m2)',
        titleFontFamily: 'poppins',
        titleFontSize: 12,
        titleFontWeight: 'normal',
        titleFontColor: '#2C3E50',
        labelFontFamily: "Inter",
        labelFontSize: 10,
        labelFontWeight: 'normal',
        labelFontColor: '#2C3E50',
        gridDashType: "dash",
        gridColor: "#AEB6BF",
        minimum: 0,
    }, {
        title: 'Temperature (°C)',
        titleFontFamily: 'poppins',
        titleFontSize: 12,
        titleFontWeight: 'normal',
        titleFontColor: '#2C3E50',
        labelFontFamily: "Inter",
        labelFontSize: 10,
        labelFontWeight: 'normal',
        labelFontColor: '#2C3E50',
        gridDashType: "dash",
        gridColor: "#AEB6BF",
        minimum: 0,
    }, {
        title: 'Relative Humidity (%RH)',
        titleFontFamily: 'poppins',
        titleFontSize: 12,
        titleFontWeight: 'normal',
        titleFontColor: '#2C3E50',
        labelFontFamily: "Inter",
        labelFontSize: 10,
        labelFontWeight: 'normal',
        labelFontColor: '#2C3E50',
        gridDashType: "dash",
        gridColor: "#AEB6BF",
        minimum: 0,
    }]

    if (wind_speed !== null & wind_speed !== undefined) {
        if (wind_speed.length > 0) {
            index_windspeed = axisy.length
            index_winddirect = axisy.length + 1
            axisy.push({
                title: 'Wind Speed (m/sec.)',
                titleFontFamily: 'poppins',
                titleFontSize: 12,
                titleFontWeight: 'normal',
                titleFontColor: '#2C3E50',
                labelFontFamily: "Inter",
                labelFontSize: 10,
                labelFontWeight: 'normal',
                labelFontColor: '#2C3E50',
                gridDashType: "dash",
                gridColor: "#AEB6BF",
                minimum: 0,
            }, {
                title: 'Wind Direction (Degree)',
                titleFontFamily: 'poppins',
                titleFontSize: 12,
                titleFontWeight: 'normal',
                titleFontColor: '#2C3E50',
                labelFontFamily: "Inter",
                labelFontSize: 10,
                labelFontWeight: 'normal',
                labelFontColor: '#2C3E50',
                gridDashType: "dash",
                gridColor: "#AEB6BF",
                minimum: 0,
            })
        }
    }
    if (water_level !== null & water_level !== undefined) {
        if (water_level.length > 0) {
            index_waterlevel = axisy.length
            axisy.push({
                title: 'Water Level (m.)',
                titleFontFamily: 'poppins',
                titleFontSize: 12,
                titleFontWeight: 'normal',
                titleFontColor: '#2C3E50',
                labelFontFamily: "Inter",
                labelFontSize: 10,
                labelFontWeight: 'normal',
                labelFontColor: '#2C3E50',
                gridDashType: "dash",
                gridColor: "#AEB6BF",
                minimum: 0,
            })
        }
    }
    const options = {
        height: 560,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">Timestamp : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format('DD MMM YYYY HH:mm') + '</p>'
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp }) + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 'normal',
            horizontalAlign: "left"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
            itemclick: toggleDataSeries
        },
        axisX: {
            interval: 1,
            intervalType: 'hour',
            labelFormatter: function (e) {
                if (window.screen.width < 576) {
                    const sxs = moment(new Date(e.value)).format('HH')
                    const nx = Number(sxs - 0)
                    if (nx >= 1 && nx % 3 !== 0) {
                        return ""
                    }
                }
                return moment(new Date(e.value)).format('HH:mm')
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: -5,
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: "orange",
                labelFontColor: "#F8F8F8",
                labelBackgroundColor: "#1A5276",
            },
        },
        axisY: axisy,
        data: [
            {
                type: 'line',
                showInLegend: true,
                legendMarkerType: "square",
                name: 'Irradiation #1',
                color: "#9AE630",
                markerType: "none",
                axisYIndex: 0,
                dataPoints: irr1,
                fillOpacity: 1,
                lineThickness: 1,
                visible: visible[0]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Irradiation #2',
                color: "#FF8904",
                markerType: "none",
                axisYIndex: 0,
                dataPoints: irr2,
                lineThickness: 1,
                visible: visible[1]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Ambient Temperature',
                color: "#FB2C36",
                markerType: "none",
                axisYIndex: 1,
                dataPoints: temp_ambient,
                lineThickness: 1,
                visible: visible[2]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Relative Humidity',
                color: "#E12AFB",
                markerType: "none",
                axisYIndex: 2,
                dataPoints: humidity,
                lineThickness: 1,
                visible: visible[3]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Panel Temperature',
                color: "#155DFC",
                markerType: "none",
                axisYIndex: 1,
                dataPoints: temp_pv,
                lineThickness: 1,
                visible: visible[4]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Tray Temperature',
                color: "#31C950",
                markerType: "none",
                axisYIndex: 1,
                dataPoints: temp_raceway,
                lineThickness: 1,
                visible: visible[5]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Wind Speed',
                color: "#3BB8DB",
                markerType: "none",
                axisYIndex: index_windspeed,
                dataPoints: wind_speed,
                lineThickness: 1,
                visible: visible[6]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Wind Direction',
                color: "#F6339A",
                markerType: "none",
                axisYIndex: index_winddirect,
                dataPoints: wind_direct,
                lineThickness: 1,
                visible: visible[7]
            }, {
                type: 'line',
                showInLegend: true,
                name: 'Water Level',
                color: "#314158",
                markerType: "none",
                axisYIndex: index_waterlevel,
                dataPoints: water_level,
                lineThickness: 1,
                visible: visible[8]
            }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );
}
